import React, { ReactNode } from 'react'
import { Step as MUIStep, SxProps } from '@mui/material'

interface StepProps {
  active?: boolean
  children?: ReactNode
  completed?: boolean
  expanded?: boolean
  sx?: SxProps
}

const Step = React.forwardRef((props: StepProps, ref: any) => {
  return (
    <MUIStep {...props} ref={ref}>
      {props.children}
    </MUIStep>
  )
})

Step.displayName = 'Step'
export default Step
